import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement } from '@nosto/preact'
import { defaultConfig } from '../config'
import { formatCurrency } from '../helpers'

export default () => {
    const {
        response: { products, keywords },
        query: { query }
    } = useAppState()

    if (!products?.hits?.length) {
        return
    }

    //console.log("@@@ products?.hits", products?.hits);
    //console.log("@@@ keywords", keywords);
    //console.log("@@@ query ", query);

    return (
        <div id="relevant-boxes" class="cj_80 ns-autocomplete   ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-p-4 ns-my-0  "
            data-nosto-element="autocomplete">
            <div class="ns-w-100 ns-mt-2 ns-mt-sm-auto" >
                <div class="ns-color-grey-dark ns-font-medium ns-font-5 subheading">
                    {window.cj?.nosto?.autocomplete_heading || "Revelant Boxes"}
                </div>
                <div class="ns-d-flex ns-flex-column ns-mt-2 ns-mb-2">
                    {products?.hits?.map((hit) => {
                        const shortDescription = (hit?.customFields || []).find(cf => cf.key === "cjx-short_description") || {};
                        return (
                            <AutocompleteElement hit={hit}>
                                <div
                                    data-url={hit.url}
                                    class="ns-product ns-d-flex flex-row ns-clickable ns-p-2"
                                    data-nosto-element="product"
                                >
                                    <a href="javascript:void(0)">
                                        <img
                                            class="  ns-object-cover hit_img"
                                            src={hit.imageUrl}
                                            alt={hit.name}
                                            width="40"
                                            height="40"
                                        />
                                    </a>
                                    <div class="ns-pl-2">
                                        <div class="hit_name ns-clipped ns-text-one-line">
                                            {hit.name}
                                            {hit.brand && (
                                                <span class="hit_brand ">
                                                    &nbsp;by {hit.brand}
                                                </span>
                                            )}
                                        </div>
                                        <div class="hit_description">
                                            {shortDescription?.value || 'View product details'}
                                        </div>
                                        <div class="hit_price">
                                            <span>
                                                {formatCurrency(hit.price)}
                                            </span>
                                            {hit.listPrice && (
                                                <span class="  ns-text-striked ns-ml-2">
                                                    {formatCurrency(
                                                        hit.listPrice
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </AutocompleteElement>
                        )
                    })}
                </div>
                <div class="view_all_btn_wrapper ns-d-flex ns-mt-2 ns-mt-sm-5">
                    <button
                        type="submit"
                        class=" view_all_btn ns-d-inline-flex ns-align-items-center ns-text-align-center"
                    >
                        View all results for "{query}"
                    </button>
                </div>
            </div>
        </div>
    )
}
